import { render, staticRenderFns } from "./reactive-relative-time.vue?vue&type=template&id=672824e7"
import script from "./reactive-relative-time.vue?vue&type=script&lang=js"
export * from "./reactive-relative-time.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports